import { RootState } from "../store";
import { NewUserProfile, NewUserRole } from "./types";

export const selectNewProfile = (state: RootState): NewUserProfile =>
  state.newProfile.newUserProfile;
export const selectNewProfileRole = (state: RootState): NewUserRole =>
  state.newProfile.newUserRole;
export const selectNewProfileAvatar = (state: RootState): string =>
  state.newProfile.newUserAvatar;
